module.exports = __webpack_public_path__ + "static/media/feed.0803929d.jpg";